/**
 * Item Extent
 *
 * @group ISOBMFF
 *
 * @beta
 */
export type ItemExtent = {
	extentIndex?: number;
	extentOffset: number;
	extentLength: number;
};
